import {Component, Inject, OnInit, ViewChild, ViewChildren, QueryList, OnDestroy, ElementRef} from '@angular/core';
import {CodemirrorComponent} from '@ctrl/ngx-codemirror';
import {FormControl, FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {environment} from '../../../../environments/environment';
import {GridService} from '../../../services/grid.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {MatSelect} from '@angular/material/select';
import {HttpService} from '../../../services/http.service';
import {ToastService} from '../../../services/toast.service';

@Component({
  selector: 'app-bulk-edit-dialog',
  templateUrl: './bulk-edit-dialog.component.html',
  styleUrls: ['./bulk-edit-dialog.component.scss']
})
export class BulkEditDialogComponent implements OnInit, OnDestroy {
  @ViewChild('codeMirror') private codeEditorCmp?: CodemirrorComponent;
  @ViewChildren('codeMirror2') codeEditorCmp2?: QueryList<CodemirrorComponent>;
  @ViewChild('backupMessageElement') backupMessageElement: ElementRef | undefined;
  public fnLibSearchValue: string = '';
  public asmTags: any = [
    {value: 'dimensions', viewValue: 'Dimensions'},
    {value: 'exclude-states', viewValue: 'Exclude states'},
    {value: 'exclude-countries', viewValue: 'Exclude countries'},
    {value: 'flat-ship-rates', viewValue: 'Flat ship rates'},
    {value: 'free-shipping', viewValue: 'Free shipping'},
    {value: 'free-ship-method', viewValue: 'Free ship method'},
    {value: 'global-free-ship-exclusion', viewValue: 'Global free ship exclusion'},
    {value: 'invalid-ship-methods', viewValue: 'Invalid ship methods'},
    {value: 'markup', viewValue: 'Markup'},
    {value: 'multi-box-dimensions', viewValue: 'Multi box dimensions'},
    {value: 'multi-box-weights', viewValue: 'Multi box weights'},
    {value: 'number-of-boxes', viewValue: 'Number of boxes'},
    {value: 'origin-zip', viewValue: 'Origin ZIP'},
    {value: 'ship-alone', viewValue: 'Ship alone'},
  ];

  public rows2: any[] = [
    {
      name: 'SKU',
      field: 'sku'
    },
    {
      name: 'Handle',
      field: 'handle'
    },
    {
      name: 'Brand',
      field: 'brand'
    },
    {
      name: 'Type',
      field: 'type'
    },
    {
      name: 'Shopify Published',
      field: 'shopify_published'
    },
    {
      name: 'Description',
      field: 'description'
    },
    {
      name: 'Obsolete',
      field: 'obsolete',
      color: '#ee3a3a'
    },
    {
      name: 'Pricing ID',
      field: 'pricing_id',
    },
    {
      name: 'List Price',
      field: 'list_price',
      color: '#3a56f2'
    },
    {
      name: 'Cost Price',
      field: 'cost_price',
      color: '#3a56f2'
    },
    {
      name: 'Sell Price',
      field: 'sell_price',
      color: '#3a56f2'
    },
    {
      name: 'Out of Stock',
      field: 'out_of_stock'
    },
    {
      name: 'Pack Qty',
      field: 'pack_qty'
    },
    {
      name: 'Image',
      field: 'image'
    },
    {
      name: 'Datasheet',
      field: 'datasheet'
    },
    {
      name: 'Installation Instructions',
      field: 'installation_instructions'
    },
    {
      name: 'URL Manufacturer',
      field: 'url_manufacturer'
    },
    {
      name: 'Body',
      field: 'body_seo'
    },
    {
      name: 'Google Category',
      field: 'google_category'
    },
    {
      name: 'Weight LBS',
      field: 'weight_lbs'
    },
    {
      name: 'Title Prefix 1',
      field: 'title_prefix_1'
    },
    {
      name: 'Title Prefix 2',
      field: 'title_prefix_2'
    },
    {
      name: 'Title Prefix 3',
      field: 'title_prefix_3'
    },
    {
      name: 'Title Suffix 1',
      field: 'title_suffix_1'
    },
    {
      name: 'Title Suffix 2',
      field: 'title_suffix_2'
    },
    {
      name: 'Title Suffix 3',
      field: 'title_suffix_3'
    },
    {
      name: 'Body Prefix 1',
      field: 'body_prefix_1'
    },
    {
      name: 'Body Prefix 2',
      field: 'body_prefix_2'
    },
    {
      name: 'Body Prefix 3',
      field: 'body_prefix_3'
    },
    {
      name: 'Body Suffix 1',
      field: 'body_suffix_1'
    },
    {
      name: 'Body Suffix 2',
      field: 'body_suffix_2'
    },
    {
      name: 'Body Suffix 3',
      field: 'body_suffix_3'
    },
    {
      name: 'Notes',
      field: 'notes'
    },
    {
      name: 'Add Tags',
      field: 'add_tags',
      color: '#a513d9'
    },
    {
      name: 'Delete Tags',
      field: 'delete_tags',
      color: '#9611c5'
    },
    {
      name: 'Shipping Tag',
      field: 'shipping_tag',
    },
    {
      name: 'ASM Tags',
      field: 'asm_tags'
    },
    {
      name: 'ASM Tag Name',
      field: 'asm_tag'
    }
  ];
  public dropDownFields: any[] = [];
  public rows: any[] = ["sku",'notes', 'pricing_id', 'delete_tags','dimensions','multi-box-dimensions', 'free-shipping', 'free-ship-method', 'ship-alone','flat-ship-rates','origin-zip','number-of-boxes','multi-box-weights','invalid-ship-methods','markup','global-free-ship-exclusion','exclude-states','exclude-countries', "shopify_published",'asm_tag','asm_value',"obsolete",'add_tags', 'shipping_tag','asm_tags', "handle","amazon_published", "out_of_stock", "replacement_sku","brand_id","type_id","description","list_price","product_tags","brand","type","cost_price","sell_price","pack_qty","image","datasheet","installation_instructions","url_manufacturer","body_seo","google_category","weight_lbs","title_prefix_1","title_prefix_2","title_prefix_3","title_suffix_1","title_suffix_2","title_suffix_3","body_prefix_1","body_prefix_2","body_prefix_3","body_suffix_1","body_suffix_2","body_suffix_3"];
  public codemirrorContent: string = '';
  public codemirrorConfig: any = {
    mode: 'javascript',
    lineNumbers: false,
    theme: 'default',
  }
  public lineNumber: number = 0;
  public charNumber: number = 0;
  public editIds;
  public type = '';
  public body;
  public pending = false;
  public disableBtn = true;

  public backupChecked = false;
  public backupMessage = '';

  public libraryAll: Array<any> = [];
  public library: Array<any> = [
    {
      title: 'Change pricing',
      subtitle: 'Increase or reduce pricing for chosen products',
      image: 'https://material.angular.io/assets/img/examples/shiba2.jpg',
      fn: 'update(`[[field-data-sell_price]]`, [[field-data-sell_price]] * 2);'
    },
    {
      title: 'Change the field value if another field is empty',
      subtitle: 'Multiply Sell Price by 2 when List Price is empty',
      fn: 'update(`[[field-data-sell_price]]`, [[field-data-list_price]] === 0 ? [[field-data-sell_price]] * 2 : [[field-data-sell_price]]);'
    },
    {
      title: 'Change Shopify publication status',
      subtitle: 'Values: true (publish), false (unpublish)',
      fn: 'update(`[[field-data-shopify_published]]`, true);',
    },
    {
      title: 'Change Obsolete status',
      subtitle: 'Values: true (Obsolete / No replacement), false (Not Obsolete)',
      fn: 'update(`[[field-data-obsolete]]`, true);',
    },
    {
      title: 'ASM Tags',
      subtitle: 'Add or remove ASM tags',
      image: 'https://material.angular.io/assets/img/examples/shiba',
      fn: 'update(`[[field-data-asm_tags]]`, `[[field-data-asm_tag]]:VALUE`);'
    },
    {
      title: 'Find and replace data',
      subtitle: 'Find a certain data and replace it with another',
      image: '',
      fn: 'update(`[[field-data-description]]`, `[[field-data-description]]`.replace(\'FIND STRING\', \'REPLACE STRING\'));'
    },
    {
      title: 'Set a tag for a certain price',
      subtitle: 'Add the \'freeship\' tag for products priced at $999 and more',
      image: '',
      // fn: '[[field-data-sell_price]] >= 999 ? addTags(`freeshipping`) : null'
      fn: 'update(`[[field-data-add_tags]]`, [[field-data-sell_price]] >= 10 ? `freeship` : ``);'
    },
    {
      title: 'Set a specific cell value',
      subtitle: 'Set a specific cell value for chosen products',
      image: '',
      fn: 'update(`[[field-data-description]]`, `Text [[field-data-sku]], $[[field-data-list_price]], more text...`);'
    },
    {
      title: 'Set a handle',
      subtitle: 'Update or create a handle for chosen products based on the formula',
      image: '',
      fn: "update(`[[field-data-handle]]`, `[[field-data-brand]]-[[field-data-sku]]-[[field-data-description]]`.toLowerCase().trim().replace(/[^\\w\\s\\-]/g, '').replace(/\\s/g, '-').replace(/--/g, '-'));"
    },
    {
      title: 'Set a brand',
      subtitle: '',
      image: '',
      fn: "update(`[[field-data-brand]]`, `ACI`);"
    },
    {
      title: 'Set a type',
      subtitle: '',
      image: '',
      fn: "update(`[[field-data-type]]`, `sensors`);"
    },
    {
      title: 'Add tag',
      subtitle: 'Add tag for chosen products',
      image: '',
      // fn: 'addTags(`freeshipping`)'
      fn: 'update(`[[field-data-add_tags]]`, `freeship`);'
    },
    {
      title: 'Remove tag',
      subtitle: 'Remove tag for chosen products',
      image: '',
      // fn: 'addTags(`freeshipping`)'
      fn: 'update(`[[field-data-delete_tags]]`, `freeship`);'
    }
  ];


  form = new FormGroup({
    type: new FormControl(this.rows[0]),
    dynamic_field_rule: new FormControl('body'),
    dynamic_field: new FormControl('img_alt'),
  });

  constructor(
    private dialogRef: MatDialogRef<BulkEditDialogComponent>,
    private http: HttpClient,
    private httpService: HttpService,
    private toastService: ToastService,
    private gridService: GridService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.editIds = data.rows;
    this.type = data.type;
    this.body = data.body;
    this.dropDownFields = this.rows2;

    this.libraryAll = this.library.slice();

    this.dropDownFields.sort((a, b) => {
      if (a.field < b.field) {
        return -1;
      }
      if (a.field > b.field) {
        return 1;
      }
      return 0;
    });
  }

  ngAfterViewInit(): void {
    this.restoreTags(this.codeEditorCmp2?.toArray());
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.restoreTags(this.codeEditorCmp2?.toArray());
    }, 100);
  }

  ngOnDestroy(): void {
    this.localStorageService.setItem('bulk-edit', this.codeEditorCmp?.codeMirror?.getValue());
  }

  hidePopup(): void {
    // @ts-ignore
    document.querySelector('.drop-down-1').classList.remove('drop-down-1--show');
    // @ts-ignore
    document.querySelector('.drop-down-2').classList.remove('drop-down-2--show');
  }

  testIndex: number = 0;
  testTarget: any = null;
  testClickOld(field: string): void {
    console.log('testClick', field);
    const originalTarget = this.testTarget.innerText;
    this.testTarget.innerText = field;

    console.log('originalTarget', originalTarget);
    let fnValue: any = this.codeEditorCmp?.codeMirror?.getValue();
    console.log('--------------------------------', fnValue);
    const fnItemIndexes = [...fnValue.matchAll(new RegExp('field-data-', 'gi'))].map(a => a.index);



    console.log('fnItemIndexes', fnItemIndexes);
    const targetIndex = fnItemIndexes.length > 1 ? fnItemIndexes[this.testIndex] : fnItemIndexes[0];
    // const targetIndex = fnItemIndexes[this.testIndex];
    console.log('✅',targetIndex, fnValue.slice(0, targetIndex));
    this.codeEditorCmp?.codeMirror?.setValue('');
    setTimeout(() => {
      this.codeEditorCmp?.codeMirror?.setValue(fnValue.slice(0, targetIndex) + field);
      let val = this.codeEditorCmp?.codeMirror?.getValue();
      console.log('+++', val);

      this.testTarget = null;
      this.testIndex = 0;
      // @ts-ignore
      document.querySelector('.drop-down-1').classList.remove('drop-down-1--show');
      // @ts-ignore
      document.querySelector('.drop-down-2').classList.remove('drop-down-2--show');
    }, 2000);
  }

  testClick(field: string): void {
    this.hidePopup();
    console.log('testClick', field);
    const originalTarget = this.testTarget.innerText;
    this.testTarget.innerText = field;

    console.log('originalTarget', originalTarget);
    let fnValue: any = this.codeEditorCmp?.codeMirror?.getValue();
    console.log('--------------------------------', fnValue);
    const fnItemIndexes = [...fnValue.matchAll(new RegExp('field-data-', 'gi'))].map(a => a.index);
    console.log('fnItemIndexes', fnItemIndexes);
    const targetIndex = fnItemIndexes[this.testIndex];
    // console.log('✅',targetIndex, fnValue.slice(0, targetIndex));
    console.log(
      '✅✅',
      fnValue.slice(0, targetIndex) + `field-data-${field}]]` + fnValue.slice(targetIndex + 11 + originalTarget.length + 2, 999)
    );

    this.codeEditorCmp?.codeMirror?.setValue(fnValue.slice(0, targetIndex) + `field-data-${field}]]` + fnValue.slice(targetIndex + 11 + originalTarget.length + 2, 999));
    setTimeout(() => {
      this.restoreTags(this.codeEditorCmp2?.toArray());
      this.initTags();
    }, 1);
    // @ts-ignore
    document.querySelector('.drop-down-1').classList.remove('drop-down-1--show');
    // @ts-ignore
    document.querySelector('.drop-down-2').classList.remove('drop-down-2--show');
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (document.querySelector('app-bulk-edit-dialog')) {
        // @ts-ignore
        document.querySelector('app-bulk-edit-dialog .fn').addEventListener('click', (e: any) => {
          const target = e.target.closest('.action-btn');
          if (target) {
            let allItems = document.querySelectorAll('.fn .action-btn');
            allItems.forEach((item, index) => {
              if (item === target) {
                console.log('INDEX', index);
                this.testIndex = index;
              }
            });
          }

          if (target && target.innerText === 'asm_tag' || this.asmTags.map((x: any) => x.value).includes(target?.innerText)) {
            console.log('AMS');
            let pos = target.getBoundingClientRect();
            const drop: any = document.querySelector('.drop-down-2');
            drop.classList.add('drop-down-2--show');
            // @ts-ignore
            drop.style.top = pos.y - (document.querySelector('mat-dialog-container').getBoundingClientRect().top - 25) + 'px';
            drop.style.left = pos.x - 40 + 'px';
            this.testTarget = target;
          } else if (target) {
            let pos = target.getBoundingClientRect();
            const drop: any = document.querySelector('.drop-down-1');
            drop.classList.add('drop-down-1--show');
            // @ts-ignore
            drop.style.top = pos.y - (document.querySelector('mat-dialog-container').getBoundingClientRect().top - 25) + 'px';
            drop.style.left = pos.x - 40 + 'px';
            this.testTarget = target;
          } else {
            // @ts-ignore
            document.querySelector('.drop-down-1').classList.remove('drop-down-1--show');
          }
        });
      }
    }, 1000);

    this.form.patchValue({
      type: null,
      dynamic_field: null
    });

    this.codeEditorCmp?.codeMirror?.setOption('mode', 'javascript');
    setTimeout(() => {
      this.codeEditorCmp?.codeMirror?.focus();
      this.addFnLibrary(this.localStorageService.getItem('bulk-edit'));
    }, 250);
  }

  onBackupClick() {
    console.log('backupMessage', this.backupMessage);
    setTimeout(() => {
      this.backupMessageElement?.nativeElement?.focus();
    }, 200);
  }

  fnLibSearchClear() {
    this.fnLibSearchValue = '';
    this.fnLibSearch('');
  }

  fnLibSearch(event: any) {
    if (this.fnLibSearchValue.length === 0) {
      this.library = this.libraryAll.slice();
    } else {
      this.library = this.libraryAll.filter(x =>
        x.subtitle.toLowerCase().includes(this.fnLibSearchValue.toLowerCase()) ||
        x.title.toLowerCase().includes(this.fnLibSearchValue.toLowerCase()) ||
        x.fn.toLowerCase().includes(this.fnLibSearchValue.toLowerCase())
      );
    }
    setTimeout(() => {
      this.restoreTags(this.codeEditorCmp2?.toArray());
      this.initTags();
    }, 1);
  }

  addFnLibrary(fn: string): void {
    // console.log('fn', fn);
    this.codeEditorCmp?.codeMirror?.setValue('');
    this.codeEditorCmp?.codeMirror?.setValue(fn);
  }

  cursorActivity($event: any): void {
    this.lineNumber = this.codeEditorCmp?.codeMirror?.getCursor().line || 0;
    this.charNumber = this.codeEditorCmp?.codeMirror?.getCursor().ch || 0;
    // console.log('cursorActivity', this.lineNumber, this.charNumber);
    const content = this.codeEditorCmp?.codeMirror?.getValue() || '';
    this.disableBtn = content.length <= 0;
  }

  setEditorContent(event: any) {
    this.initTags();
    setTimeout(() => {
      // console.log('this.codeEditorCmp2?.toArray()', this.codeEditorCmp2?.toArray());
      this.restoreTags(this.codeEditorCmp2?.toArray());
    }, 4000)
  }

  clickTag(selectValue: string): void {
    console.log('clickTag', selectValue);
    let snippet = `[[field-data-${selectValue}]]`;
    this.codeEditorCmp?.codeMirror?.getDoc().replaceRange(snippet, {line: this.lineNumber, ch: this.charNumber});
    let htmlNode = document.createElement("span");
    htmlNode.textContent = selectValue;
    htmlNode.classList.add('action-btn');
    htmlNode.setAttribute('contenteditable', 'false');
    this.codeEditorCmp?.codeMirror?.getDoc().markText({line: this.lineNumber, ch: this.charNumber - snippet.length }, {line: this.lineNumber,ch: this.charNumber}, {
      readOnly: false,
      replacedWith: htmlNode
    });
    this.form.patchValue({
      type: null
    });
    setTimeout(() => {
      this.codeEditorCmp?.codeMirror?.focus();
    }, 250);
  }

  restoreTags(array: any): void {
    array.forEach((codemirror: any) => {
      const indexes: any = [];
      let text = codemirror.codeMirror?.getValue() || '';
      this.rows.forEach(row => {
        let snippet: any = `\\[\\[field-data-${row}\\]\\]`;
        const regEx = new RegExp(snippet, 'gi');
        const i = [...text.matchAll(regEx)];
        let finder: number = text?.indexOf(snippet.replaceAll('\\', ''));
        if (finder !== -1) {
          indexes.push({
            index: i.map(x => x.index),
            snippet: snippet.replaceAll('\\', ''),
            row
          })
        }
      });

      indexes.forEach((item: any) => {
        item.index.forEach((i: any) => {
          let htmlNode = document.createElement("span");
          htmlNode.textContent = item.row;
          htmlNode.classList.add('action-btn');
          htmlNode.setAttribute('contenteditable', 'false');
          codemirror.codeMirror?.getDoc().markText({line: 0, ch: i}, {line: 0, ch: i + item.snippet.length}, {
            readOnly: false,
            replacedWith: htmlNode
          });
        });
      });
    });
  }

  initTags(): void {
    // console.log('restoreTags');
    const indexes: any = [];
    let text = this.codeEditorCmp?.codeMirror?.getValue() || '';
    this.rows.forEach(row => {
      let snippet: any = `\\[\\[field-data-${row}\\]\\]`;
      const regEx = new RegExp(snippet, 'gi');
      const i = [...text.matchAll(regEx)];
      let finder: number = text?.indexOf(snippet.replaceAll('\\', ''));
      if (finder !== -1) {
        indexes.push({
          index: i.map(x => x.index),
          snippet: snippet.replaceAll('\\', ''),
          row
        })
      }
    });

    indexes.forEach((item: any) => {
      item.index.forEach((i: any) => {
        let htmlNode = document.createElement("span");
        htmlNode.textContent = item.row;
        htmlNode.classList.add('action-btn');
        htmlNode.setAttribute('contenteditable', 'false');
        this.codeEditorCmp?.codeMirror?.getDoc().markText({line: 0, ch: i}, {line: 0, ch: i + item.snippet.length}, {
          readOnly: false,
          replacedWith: htmlNode
        });
      });
    });
    // console.log('indexes', indexes);
  }

  onSubmitTest() {
    let val: any = this.codeEditorCmp?.codeMirror?.getValue();
    for (const tag of this.asmTags.map((asm: any) => asm.value)) {
      console.log('tag', tag);
      val = val.replace(`[[field-data-${tag}]]`, tag);
    }
    // this.asmTags.map((asm: any) => asm.value)
    // if () {
    //
    // }
    console.log(val);
  }
  onSubmit() {
    const run = () => {
      this.pending = true;
      let value: any = this.codeEditorCmp?.codeMirror?.getValue();
      for (const tag of this.asmTags.map((asm: any) => asm.value)) {
        value = value.replace(`[[field-data-${tag}]]`, tag);
      }

      if (this.type === 'all') {
        const sendValue = this.codeEditorCmp?.codeMirror?.getValue().replace(/update\(`\[\[field-data-(.*)\]\]`,/, `update('$1',`);
        this.http.post(environment.API_PATH + '/bulk/all', {
          str: sendValue,
          ids: this.editIds
        }).subscribe(res => {
          console.log('🟢', res);
          this.pending = false;

          this.dialogRef.close();
        });
      } else if (this.type === 'filtered') {
        let body = {
          field: value.match(/update\(`\[\[field-data-(.*)\]\]`,/)[1],
          action: value.match(/,(.*)\);/)[1].trim(),
          filterModel: this.gridService.gridApi?.getFilterModel()
        }
        console.log(' 🎃', body);
        this.http.post(environment.API_PATH + '/bulk/filtered', body).subscribe(res => {
          console.log('🎃🎃', res);
          this.pending = false;
          this.dialogRef.close();
        }, error => {
          console.error('✳️', error);
          this.pending = false;
        });
      } else if (this.type === 'selected') {
        let body = null;
        console.log('{{{{', value.match(/update\(`\[\[field-data-(.*)\]\]`,/));
        console.log('ACTION', value.match(/,(.*)\);/));
        try {
          body = {
            field: value.match(/update\(`\[\[field-data-(.*)\]\]`,/)[1],
            action: value.match(/,(.*)\);/)[1].trim(),
            type: 'selected',
            ids: this.editIds
          }
          console.log(' 🎃', body);
        } catch (e) {
          // console.error('✳️', e);
        }

        this.http.post(environment.API_PATH + '/bulk/selected', body).subscribe(res => {
          console.log('_____=', res);
          this.pending = false;
          this.dialogRef.close();
        }, error => {
          console.error('✳️', error);
          this.pending = false;
        })
      }
    }

    if (this.backupChecked) {
      this.toastService.info('Backup has been started. Please wait.');
      this.pending = true;
      this.httpService.post(environment.API_PATH + '/backup/create', {
        name: this.backupMessage.trim()
      }).subscribe(() => {
        this.backupMessage = '';
        this.toastService.success('Backup created successfully.');
        run();
      });
    } else {
      run();
    }
  }
}
